import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=4e1b4aa1&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1b4aa1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e1b4aa1')) {
      api.createRecord('4e1b4aa1', component.options)
    } else {
      api.reload('4e1b4aa1', component.options)
    }
    module.hot.accept("./goods.vue?vue&type=template&id=4e1b4aa1&scoped=true", function () {
      api.rerender('4e1b4aa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/condom/goods.vue"
export default component.exports